$(document).ready(function () {
    $("#table-discount-by-lots").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: '/admin/get-lots-discount',
        columns: [
            {data: 'discount_lots.description', name: 'discount_lots.description'},
            {data: 'discount', name: 'discount'},
            {data: 'initial_date', name: 'initial_date'},
            {data: 'final_date', name: 'final_date'},
        ],
        "columnDefs": [{
            "targets": 4,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                let status = get_global_status(row.status)
                return '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn m-1 button_almadia_reverse ' +
                    'lots-discount-by-lots-edit btn-sm"' +
                    'data-data ="' + row + '"><i class="far fa-edit"></i></button> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                    'class="btn m-1 btn-' + status.color_clas + ' change-lots-discount-status btn-sm"  ' +
                    'data-uuid ="' + row.uuid + '"><i class="' + status.icon + '"></i></button>' +

                    button_lots_discount_delete(row.status, row.uuid)

            }
        }]
    });
    const list_lots_discounts = $("#table-discount-by-lots").DataTable()

    $("#add-discount_by_lots").on('click', function (e) {
        e.preventDefault()
        $(".item-lot-discount-dir").val('add')
        $("#modal-discount-by-lots").modal('show')
        $('.item-lot-discount-lote_id option:not(:selected)').prop('disabled', false);
        $('.item-lot-discount-lote_id').prop('disabled', false);
        $('.item-lot-discount-lote_id').val('').trigger('chosen:updated');
        $(".title-discount-by-lots").html('Nuevo')
        clearForm()
    })

    $("#table-discount-by-lots tbody").on('click', '.lots-discount-by-lots-edit', function (e) {
        e.preventDefault()
        $("#modal-discount-by-lots").modal('show')
        $(".item-lot-discount-dir").val('edit')
        $('.item-lot-discount-lote_id option:not(:selected)').prop('disabled', true);
        $(".title-discount-by-lots").html('Editar')
        rowData = list_lots_discounts.row($(this).parents('tr')).data();
        $.each(rowData, function (index, value) {
            $(".item-lot-discount-" + index).val(value);
            if (index == 'lote_id') {
                $('.item-lot-discount-lote_id').prop('disabled', true);
                $('.item-lot-discount-lote_id').val(value);
                $('.item-lot-discount-lote_id').trigger("chosen:updated")
            }
            if (index == "uuid") {
                $(".item-lot-discount-uuid").val(value)
            }
        })
    })

    $("#table-discount-by-lots tbody").on('click', '.change-lots-discount-status', function (e) {
        e.preventDefault()
        let data = new FormData()
        data.append('uuid', $(this).data('uuid'))
        sendData(data, '/admin/change-lots-discount-status')
    })

    $("#table-discount-by-lots tbody").on('click', '.delete-lots-discount', function (e) {
        e.preventDefault()
        let data = new FormData()
        data.append('uuid', $(this).data('uuid'))
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                sendData(data, '/admin/delete-lots-discount')
            }
        })

    })

    $("#form-discount-by-lots").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        sendData(data, '/admin/' + $(".item-lot-discount-dir").val() + '-lots-discount')
    })


    function button_lots_discount_delete(status, uuid) {
        if (status === "D") {
            return button = '<a href="#" data-toggle="tooltip" data-placement="top" title="Eliminar" ' +
                'class="btn btn-danger delete-lots-discount btn-sm m-1"  ' +
                'data-uuid ="' + uuid + '"><i class="fa-solid fa-trash-can-arrow-up"></i></a> ';
        }
        return "";
    }

    function sendData(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                console.log(response)
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (response.success == "success") {
                        $("#modal-discount-by-lots").modal('hide')
                        $("#table-discount-by-lots").DataTable().ajax.reload();
                        alertSuccess(response.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function clearForm() {
        $(".item-lot-discount-lote_id").val('')
        $(".item-lot-discount-discount").val('')
        $(".item-lot-discount-initial_date").val('')
        $(".item-lot-discount-final_date").val('')
        $(".item-lot-discount-id").val('')
        $('.item-lot-discount-lote_id').val('');
        $('.item-lot-discount-lote_id').trigger("chosen:updated");
    }
})
